// Легенда зон таблицы: серверная подпись зоны (zone) → цвет по порядку появления (zoneColors), точка 8 + подпись.
import styles from './ZoneLegend.module.css';

export function ZoneLegend({ zones, className }: { zones: Map<string, string>; className?: string }) {
  if (!zones.size) return null;
  return (
    <div className={`${styles.legend} ${className ?? ''}`}>
      {[...zones.entries()].map(([name, color]) => (
        <span key={name} className={styles.item}><span className={styles.dot} style={{ background: color }} />{name}</span>
      ))}
    </div>
  );
}
